import React from 'react';
import { Outlet, Link, useLocation, Navigate } from 'react-router-dom';
import './Admin.scss';

const DashboardsLayout = () => {
    const location = useLocation();

    const dashboardTabs = [
        { path: '/admin/dashboards/overview', label: 'Overview' },
        { path: '/admin/dashboards/revenue', label: 'Revenue' },
        { path: '/admin/dashboards/creators', label: 'Creators' },
        { path: '/admin/dashboards/users', label: 'Users' }
    ];

    // Check if current path matches any dashboard tab
    const isDashboardRoute = dashboardTabs.some(tab => location.pathname === tab.path);

    // If on /admin/dashboards, redirect to overview
    if (location.pathname === '/admin/dashboards') {
        return <Navigate to="/admin/dashboards/overview" replace />;
    }

    return (
        <div className="dashboards-layout">
            <div className="dashboard-tabs">
                {dashboardTabs.map((tab) => (
                    <Link
                        key={tab.path}
                        to={tab.path}
                        className={`dashboard-tab ${location.pathname === tab.path ? 'active' : ''}`}
                    >
                        {tab.label}
                    </Link>
                ))}
            </div>
            <div className="dashboard-content">
                <Outlet />
            </div>
        </div>
    );
};

export default DashboardsLayout;

